module.exports = function(name) {
	return new SharedWorker(__webpack_public_path__ + "9e23c3a154ba3043c85f.sharedworker.js", name);
};